export class DenouncedGeneral {
    get id() {
        return this.denouncedGeneralState.id;
    }
    get diligenceNumber() {
        return this.denouncedGeneralState.diligenceNumber;
    }
    get denouncedThirId() {
        return this.denouncedGeneralState.denouncedThirId;
    }
    get wantToDeclare() {
        return this.denouncedGeneralState.wantToDeclare;
    }
    get familyNotice() {
        return this.denouncedGeneralState.familyNotice;
    }
    get medicalExamination() {
        return this.denouncedGeneralState.medicalExamination;
    }
    get interpreter() {
        return this.denouncedGeneralState.interpreter;
    }
    get appointLawyer() {
        return this.denouncedGeneralState.appointLawyer;
    }
    get publicDefender() {
        return this.denouncedGeneralState.publicDefender;
    }
    get optionalPart() {
        return this.denouncedGeneralState.optionalPart;
    }
    get own_arms() {
        return this.denouncedGeneralState.own_arms;
    }
    get arms_types() {
        return this.denouncedGeneralState.arms_types;
    }
    get meetWhistleblower() {
        return this.denouncedGeneralState.meetWhistleblower;
    }
    get relationshipWithComplainant() {
        return this.denouncedGeneralState.relationshipWithComplainant;
    }
    get userId() {
        return this.denouncedGeneralState.userId;
    }
    set diligenceNumber(diligenceNumber) {
        this.denouncedGeneralState.diligenceNumber = diligenceNumber;
    }
    set denouncedThirId(denouncedThirId) {
        this.denouncedGeneralState.denouncedThirId = denouncedThirId;
    }
    set wantToDeclare(wantToDeclare) {
        this.denouncedGeneralState.wantToDeclare = wantToDeclare;
    }
    set familyNotice(familyNotice) {
        this.denouncedGeneralState.familyNotice = familyNotice;
    }
    set medicalExamination(medicalExamination) {
        this.denouncedGeneralState.medicalExamination = medicalExamination;
    }
    set interpreter(interpreter) {
        this.denouncedGeneralState.interpreter = interpreter;
    }
    set appointLawyer(appointLawyer) {
        this.denouncedGeneralState.appointLawyer = appointLawyer;
    }
    set publicDefender(publicDefender) {
        this.denouncedGeneralState.publicDefender = publicDefender;
    }
    set optionalPart(optionalPart) {
        this.denouncedGeneralState.optionalPart = optionalPart;
    }
    set own_arms(own_arms) {
        this.denouncedGeneralState.own_arms = own_arms;
    }
    set arms_types(arms_types) {
        this.denouncedGeneralState.arms_types = arms_types;
    }
    set meetWhistleblower(meetWhistleblower) {
        this.denouncedGeneralState.meetWhistleblower = meetWhistleblower;
    }
    set relationshipWithComplainant(relationshipWithComplainant) {
        this.denouncedGeneralState.relationshipWithComplainant = relationshipWithComplainant;
    }
    set userId(userId) {
        this.denouncedGeneralState.userId = userId;
    }
    constructor(denouncedGeneralState) {
        this.denouncedGeneralState = denouncedGeneralState;
    }
    getState() {
        return this.denouncedGeneralState;
    }
}
